import React, { useState, useEffect } from 'react';

// Yerel veri
const initData = {
    heading: "Organizatörler İçin Socia",
    //headingText: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Similique dolor ut iusto vitae autem neque eum ipsam, impedit asperiores vel cumque laborum dicta repellendus inventore voluptatibus et explicabo nobis unde.",
    thumbOne: "/img/discover_thumb.png"
};

// Yerel keşfet verileri
const discoverData = [
    {
        id: 1,
        iconClass: "fas fa-check",
        text: "Etkinliklerinizin görünürlüğünü artırın!"
    },
    {
        id: 2,
        iconClass: "fas fa-check",
        text: "Binlerce aktif kullanıcı etkinliklerinizi keşfetmek için hazır!"
    },
    {
        id: 3,
        iconClass: "fas fa-check",
        text: "Uygulama üzerinden kolayca etkinlik oluştur!"
    },
    {
        id: 4,
        iconClass: "fas fa-check",
        text: "Etkinlikleriniz otomatik olarak hatırlatılır!"
    }
];

// Yerel keşfet simgeleri
const discoverIcon = [
    {
        id: 1,
        iconClass: "fas fa-bell"
    },
    {
        id: 2,
        iconClass: "fas fa-envelope-open"
    },
    {
        id: 3,
        iconClass: "fas fa-video"
    }
];

const DiscoverSection = () => {
    const [data, setData] = useState({});
    const [discovers, setDiscovers] = useState([]);
    const [icons, setIcons] = useState([]);

    useEffect(() => {
        // API yerine yerel sabitlerden veri ayarlama
        setData(initData);
        setDiscovers(discoverData);
        setIcons(discoverIcon);
    }, []);

    return (
        <section 
            className="section discover-area overflow-hidden ptb_100"
            style={{ 
                background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                color: 'white'
            }}
        >
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-12 col-lg-6 order-2 order-lg-1">
                        {/* Discover Thumb */}
                        <div className="service-thumb discover-thumb mx-auto pt-5 pt-lg-0">
                            <img src={data.thumbOne} alt="" />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 order-1 order-lg-2">
                        {/* Discover Text */}
                        <div className="discover-text pt-4 pt-lg-0">
                            <h2 className="pb-4 pb-sm-0" style={{ color: 'white' }}>{data.heading}</h2>
                            <p className="d-none d-sm-block pt-3 pb-4" style={{ color: 'white' }}>{data.headingText}</p>
                            {/* Check List */}
                            <ul className="check-list">
                                {discovers.map((item, idx) => (
                                    <li key={`do_${idx}`} className="py-2">
                                        {/* List Box */}
                                        <div className="list-box media">
                                            <span className="icon align-self-center" style={{ color: '#a074f7' }}>
                                                <i className={item.iconClass} />
                                            </span>
                                            <span className="media-body pl-2" style={{ color: 'white' }}>
                                                {item.text}
                                            </span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DiscoverSection;